var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"follow-up-suggestion"},[_vm._v(" 请联系您所在的社区卫生服务中心获取随访建议。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }